import { namedStateMapProvider } from "./namedState";

export const mobileItemDetailState = namedStateMapProvider('mobileItem');